import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";
import TaskStatusManager from 'src/core/gd/manager/task-status-manager';
import HintPopover from "src/core/gd-ui/hint-popover/hint-popover";
import TaskStatusSelectorPopover from "./popover";
import PopoverPosition from "../../../gd-components/gd-popover/popover-position";

// STILL USED IN BULK EDIT potomu chto tam ono rabotaet ....

export default class StatusSelector extends React.Component {

    static propTypes = {
        projectId: PropTypes.string,                    // project id to show custom tasks workflow if set
        taskTypeId: PropTypes.string,                   // task type ID
        value: PropTypes.string,                        // current statusId
        autoSelectStatus: PropTypes.bool,               // select first available status from list if no value

        // Display customizations
        placeholder: PropTypes.string,                  // can be used when no status i.e. re-open task (hotya tam mozno i pervii kstati brat' avtomatom !
        hint: PropTypes.bool,                           // if true - show hint messages
        doNotShowClosedStatuses: PropTypes.bool,        // if true do not show closed / cancelled statuses - used in task reopen

        popoverHint: PropTypes.string,

        // callbacks
        onUserSelect: PropTypes.func,
        onChange: PropTypes.func,
        onTogglePopover: PropTypes.func,                // hez zachem no vezde est'
        onAutoSelect: PropTypes.func,                   // is called if autoSelectStatus enabled and some status auto selected

        // look and feel
        // ui5-card - used in old my work
        // control-button-24 eto new used in new my-work
        renderValue: PropTypes.oneOf(
            ['color-block-26', 'color-round-block-22', 'task-view', 'task-view-inline',
                'form', 'table-inline', 'func', 'task-reply', 'ui5', 'ui5-18', 'ui5-22', 'ui5-card','control-button-24']).isRequired, // render value view name
        renderValueFunc: PropTypes.func,        // func for external render function if passwed used to render instead of default

        // options: PropTypes.array.isRequired,
        disabled: PropTypes.bool,                       // if true not editable (!) just view maybe right name is editable not disabled ?

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,
        attachmentType: PropTypes.string, //full, horizontal, vertical


        minimized: PropTypes.bool,                      // used in task reply mode tre by defualt
    };

    static defaultProps = {
        autoSelectStatus: false,
        hint: true,
        doNotShowClosedStatuses: false,

        placeholder: 'Select status',

        disabled: false,

        attachment: "top right",
        targetAttachment: "top left",
        targetOffset: "0 0",
        attachmentType: "full",

        minimized: true
    };

    constructor(props) {
        super(props);

        this.state = {
            showPopover: false,
            value: this.getDefaultValue(this.props),
            minimized: props.minimized             // used in task reply mode when current status = icon and if selected pill
        };
    }

    // if rerender with new value
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value) {
            this.setState({
                value: this.getDefaultValue(nextProps)
            });
        }
    }

    getDefaultValue = (props) => {
        let res;
        if (props.autoSelectStatus && !props.value) {
            const taskStatuses = TaskStatusManager.getTaskStatuses({projectId:props.projectId, taskTypeId:props.taskTypeId});

            const orderedOpenStatuses = _.chain(taskStatuses)
                .filter(m=>![gd.const.systemStatus.COMPLETED, gd.const.systemStatus.CANCELLED].includes(m.systemStatus))
                .sortBy("systemStatus")
                .value();

            res = orderedOpenStatuses[0] ? orderedOpenStatuses[0].id : null;
            if(this.props.onAutoSelect) this.props.onAutoSelect(res);
        } else {
            res = props.value;
        }

        return res;
    };

    // Checkbox
    onCheckboxClick = (e) => {
        if (this.props.disabled) return;

        const { projectId, taskTypeId } = this.props;
        e.stopPropagation();

        // ok we clicked checkbox
        const status = gd.session.statuses.get(this.state.value);
        let newStatus;

        const taskStatuses = TaskStatusManager.getTaskStatuses({projectId:projectId, taskTypeId:taskTypeId});

        if (gd.const.systemStatus.isOpen(status.systemStatus)) {
            // we need to close - find closed statuses
            const orderedClosedStatuses = _.chain(taskStatuses)
                .filter(m=>m.systemStatus === gd.const.systemStatus.COMPLETED || m.systemStatus === gd.const.systemStatus.CANCELLED)
                .sortBy("systemStatus")
                .value();

            newStatus = orderedClosedStatuses[0].id;
        } else {
            // we need to reopen
            const orderedOpenStatuses = _.chain(taskStatuses)
                .filter(m=>m.systemStatus !== gd.const.systemStatus.COMPLETED && m.systemStatus !== gd.const.systemStatus.CANCELLED)
                .sortBy("systemStatus")
                .value();

            newStatus = orderedOpenStatuses[0].id;
        }

        this.onStatusClick(newStatus);
    }

    togglePopover = (e) => {
        if (e) e.stopPropagation();

        if (!this.props.disabled) {
            const showPopover = !this.state.showPopover;
            this.setState({
                showPopover: showPopover
            },()=>{
                if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover);
            });
        }
    }

    hidePopover = (value) => {
        this.setState({
            showPopover: false,
            value: value ? value : this.state.value,
            minimized: value ? false : this.state.minimized     // used in task-reply render mode
        });
        if (this.props.onTogglePopover) this.props.onTogglePopover(false);
    }

    onStatusClick = (value) => {
        let { onUserSelect, options } = this.props;

        let curStatus = _.find(options, (o) => o.value === this.state.value);
        if (!curStatus) curStatus = gd.session.statuses.get(this.state.value);
        //let newStatus = _.find(options, (o) => o.value == value);

        if (curStatus && gd.const.systemStatus.isClosed(curStatus.systemStatus)) {
            this.hidePopover();
        } else {
            this.hidePopover(value);
        }
        if (onUserSelect) onUserSelect(value, this.confirmCallback);
    }

    confirmCallback = (value, actionRequiredUserId) => {
        let prevValue = this.state.value;
        this.setState({
            showPopover: false,
            value: value
        });

        let { onChange } = this.props;
        if (onChange) onChange(prevValue, value, actionRequiredUserId);
    }

    renderPopover() {
        if (!this.state.showPopover) return false;

        const popoverPosition = new PopoverPosition({
            attachment          : this.props.attachment,
            targetAttachment    : this.props.targetAttachment,
            targetOffset        : this.props.targetOffset,
            attachmentType      : this.props.attachmentType,
            constraints         : [{
                to: "window",
                attachment: "together",
                pin: true,
            }]
        })

        return (
                <TaskStatusSelectorPopover hidePopover={this.hidePopover}
                                           projectId={this.props.projectId}
                                           taskTypeId={this.props.taskTypeId}
                                           onStatusSelect={this.onStatusClick}
                                           togglePopover={this.togglePopover}
                                           hint={this.props.hint}
                                           doNotShowClosedStatuses={this.props.doNotShowClosedStatuses}
                                           popoverPosition={popoverPosition}
                                           getTarget={()=>findDOMNode(this)}
                />
        )
    }

    _getValues = () => {
        // value label
        let valueLabel  = this.props.placeholder;
        let statusColor = 1;
        let isOpen      = true;

        if (this.state.value) {
            const status = gd.session.statuses.get(this.state.value);

            if (status) {
                valueLabel = status.name;
                statusColor = status.color;
                isOpen = gd.const.systemStatus.isOpen(status.systemStatus);
            }
        }

        return {valueLabel, statusColor, isOpen};
    }

    renderValue() {
        const {valueLabel, statusColor, isOpen} = this._getValues();

        let curValueClasses;

        let checkboxValue = false;

        switch (this.props.renderValue) {

            case 'table-inline':
                curValueClasses = Classes('cur-value', 'table-inline-type', 'gd-scf-'+statusColor);

                return (
                    <div className={curValueClasses}>
                        <div className="name">{valueLabel}</div>
                    </div>
                );

            case 'form':
                curValueClasses = Classes('cur-value', 'form', 'gd-scf-'+statusColor);

                return (
                    <div className={curValueClasses}>

                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>

                    </div>
                );

            case 'task-view':
                curValueClasses = Classes('cur-value', 'task-view', 'status-color-'+statusColor );

                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                return (
                    <div className={curValueClasses}>
                        {!this.props.disabled &&
                        <div className="checkbox" onClick={this.onCheckboxClick}>{checkboxValue}</div>}

                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>

                    </div>
                );

            case 'task-view-inline':
                curValueClasses = Classes('cur-value', 'task-view-inline', 'gd-scf-'+statusColor, {
                    'disabled': this.props.disabled
                });

                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                return (
                    <div className={curValueClasses}>
                        {!this.props.disabled &&
                        <div className="checkbox" onClick={this.onCheckboxClick}>{checkboxValue}</div>}

                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>

                    </div>
                );

            case 'color-block-26':
                curValueClasses = Classes('cur-value', 'color-block-26', 'status-color-'+statusColor );
                if (!isOpen) checkboxValue = <span className="i5-checkbox-ok"> </span>;

                const checkboxClasses = (isOpen)?'checkbox':'checkbox checked';

                return (
                    <div className={curValueClasses}>
                        <div className={checkboxClasses} onClick={this.onCheckboxClick}>{checkboxValue}</div>
                        <div className="name">{valueLabel}</div>
                        <span className="i5-big-angle-down"> </span>

                    </div>
                );

            case 'task-reply':

                // 'gd-scf-'+statusColor,
                curValueClasses = Classes('cur-value', 'task-reply-type', {
                    minimized: this.state.minimized,
                    'i5-status-update': this.state.minimized,

                });


                if (this.state.minimized) {
                    return (
                        <div className={curValueClasses}/>
                    );

                } else {

                    return (
                        <div className={curValueClasses}>
                            <div className={Classes("name", 'gd-scf-'+statusColor )}>{valueLabel}</div>
                            <div className="arrow-icon i5-big-angle-down"> </div>
                        </div>
                    );
                }

            case 'color-round-block-22':
                curValueClasses = Classes('cur-value', 'color-round-block-22', 'status-color-'+statusColor );
                return (
                    <div className={curValueClasses}>
                        <div className="name">{valueLabel}</div>
                    </div>
                );

            case 'ui5':
            case 'ui5-18':
            case 'ui5-22':
                curValueClasses = Classes('ui5-status-list', 'status-c{0}'.f(statusColor), {
                    's18': this.props.renderValue === 'ui5-18',
                    's22': this.props.renderValue === 'ui5-22'
                });
                return (
                    <div className={curValueClasses}>
                        {valueLabel}
                    </div>
                );
        }
    }

    render() {
        const classes = Classes('gd-select-status', '{0}-type'.f(this.props.renderValue), this.props.className, {
            disabled: this.props.disabled
        });

        switch (this.props.renderValue) {
            case 'ui5-card':
                const {statusColor} = this._getValues();
                return (
                    <div className={Classes("action-button with-border with-dot i5-status-update", this.props.className)} onClick={!this.props.disabled ? this.togglePopover : null}>
                        <div className={Classes('colored-dot', 'status-color-{0}'.f(statusColor))}/>
                        {this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )

            case 'control-button-24':
            {
                const {statusColor} = this._getValues()
                return (
                    <div className={Classes("ui5-control-button s-24 fs-16 with-dot i5-status-with-dot", this.props.className)} onClick={!this.props.disabled ? this.togglePopover : null}>
                        <div className={Classes('color-dot', 'status-color-{0}'.f(statusColor))}/>
                        {this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                )
            }
            default:
                return (
                    <div className={classes} onClick={!this.props.disabled ? this.togglePopover : null}>
                        {this.renderValue()}
                        {this.renderPopover()}
                        {this.props.popoverHint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.popoverHint}/>}
                    </div>
                );
        }
    }
}